/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Back_To_AppInputs */

const en_nav_back_to_app = /** @type {(inputs: Nav_Back_To_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Backstage`)
};

/**
* | output |
* | --- |
* | "Back to Backstage" |
*
* @param {Nav_Back_To_AppInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_back_to_app = /** @type {((inputs?: Nav_Back_To_AppInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Back_To_AppInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_back_to_app(inputs)
});